<template>
  <div class="radio-sprite">
    <sprite class="radio-sprite__sprite radio-sprite__sprite--active" id="app/radio-checked" v-if="active" />
    <sprite class="radio-sprite__sprite" id="app/radio-empty" v-else />
  </div>
</template>

<script>
import Sprite from "@/shared/sprite"
import "/wds/sprites/app/radio-empty"
import "/wds/sprites/app/radio-checked"

export default {
  name: "RadioSprite",
  components: {
    Sprite
  },
  props: {
    active: { type: Boolean, default: null }
  }
}
</script>

<style lang="scss">
.radio-sprite {
  position: relative;

  width: $spacing-24;
  height: $spacing-24;

  &__sprite {
    position: relative;
    z-index: 2;

    color: $dark-grey;

    &--active {
      color: $midnight;
    }
  }

  &:before {
    content: "";

    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;

    display: block;
    width: 100%;
    height: 100%;

    background-color: $white;

    border-radius: 50%;

    transform: translate(-50%, -50%);
  }
}
</style>
